import React, { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Image,
  Modal,
  InputGroup,
  Form,
  DropdownButton,
  Dropdown,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../state/index";
import OnlineEnquiryAPI from "../utils/api/OnlineEnquiryAPI";
import { format } from "date-fns";
import { Badge, Button } from "antd";
import { notify_error, notify_success } from "./Notify";
import cookie from "js-cookie";
import { useSearchParams } from "react-router-dom";
// import "./OnlineEnquiryTable.css";
import EnquiryAPI from "../utils/api/EnquiryAPI";
import { Pagination } from "antd";
import FilterOnlineEnquiry from "./FilterOnlineEnquiry";
// import { Container, Row, Col } from "react-bootstrap";
import { EnquiryContext } from "../state/context/EnquiryProvider";
import "./Table.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import CreateEnquiry from "./createEnquiry";
import UserAPI from "../utils/api/UserAPI";
import LeadProfile from "./leadProfile";
import { TableSkeleton } from "./skeletons";

const MaskedField = ({ value, leadId, field }) => {
  const [revealed, setRevealed] = useState(null);
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!revealed) return;
    const handleOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setRevealed(null);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, [revealed]);

  if (!value) return <span style={{ color: "#9CA3AF" }}>—</span>;

  const handleReveal = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (loading || revealed) return;
    setLoading(true);
    try {
      const res = await OnlineEnquiryAPI.logLeadView({ _id: leadId, field });
      if (res?.data?.status && res?.data?.data?.value) {
        setRevealed(res.data.data.value);
      } else {
        notify_error(res?.data?.message || "Unable to reveal");
      }
    } catch (err) {
      notify_error("Failed to reveal contact");
    } finally {
      setLoading(false);
    }
  };

  return (
    <span
      ref={containerRef}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        fontVariantNumeric: "tabular-nums",
      }}
    >
      <span
        style={{
          wordBreak: "break-all",
          color: revealed ? "#1F2937" : "#6B7280",
          letterSpacing: revealed ? "normal" : "0.5px",
        }}
      >
        {revealed || value}
      </span>
      {!revealed && (
        <button
          type="button"
          onClick={handleReveal}
          disabled={loading}
          title={`Reveal ${field}`}
          aria-label={`Reveal ${field}`}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "24px",
            height: "24px",
            padding: 0,
            border: "none",
            background: "transparent",
            color: "#663399",
            borderRadius: "4px",
            cursor: loading ? "wait" : "pointer",
            opacity: loading ? 0.5 : 1,
            transition: "background 0.15s",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = "#F3EEFA")}
          onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
        >
          <VisibilityOutlinedIcon style={{ fontSize: "18px" }} />
        </button>
      )}
    </span>
  );
};

const EnquiryTable = () => {
  const {
    activepage,
    recperpage,
    data,
    SetActivePage,
    SetRecPerPage,
    setDate,
    totalData,
    setTotalData,
    filter,
    setFilter,
    search,
    SetSearch,
    handlePageChange,
    applyFilter,
    filterEmptySelected,
    handleApplyFilter,
    step,
    setStep,
    activeData,
  } = React.useContext(EnquiryContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { top_loader } = bindActionCreators(actionCreators, dispatch);
  const sno = recperpage * (activepage - 1);
  const [loading, setLoading] = useState(false);
  const [defaultFilter, setDefaultFilter] = useState([]);
  const [searchParams] = useSearchParams();
  const [title, setTitle] = useState("All Enquiry List");
  const [totalEnquiry, setTotalEnquiry] = useState(0);
  const [totalOnlineEnquiry, setTotalOnlineEnquiry] = useState(0);
  const [totalAdOnlineEnquiry, setTotalAdOnlineEnquiry] = useState(0);
  const [lastMonthWalkInEnquiry, setLastMonthWalkInEnquiry] = useState(0);
  const [currentMonthWalkInEnquiry, setCurrentMonthWalkInEnquiry] = useState(0);
  const [currentMonthAdEnquiry, setCurrentMonthAdEnquiry] = useState(0);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [currentMonthOrganicEnquiry, setCurrentMonthOrganicEnquiry] =
    useState(0);
  const [lastMonthAdEnquiry, setLastMonthAdEnquiry] = useState(0);
  const [lastMonthOrganicEnquiry, setLastMonthOrganicEnquiry] = useState(0);
  const [isFilter, setIsFilter] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [handlers, setHandlers] = useState([]);
  const [isFormValidate, setFormValidate] = useState(false);
  const [activeTransfer, setActiveTransfer] = useState(false);
  const [transferEnquiry, setTransferEnquiry] = useState(false);
  const [transferRole, setTransferRole] = useState("");
  const [activeId, setActiveId] = useState("");
  const [Index, setIndex] = useState(0);
  const [search1, setSearch1] = useState("");
  const [enquiry, setEnquiry] = useState({
    program: "",
    name: "",
    email: "",
    mobile_number: "",
    form_location: "",
    enquiry_type: "",
    source: "",
    reference: "",
    state: "",
    city: "",
  });
  const [isTelephonic, setIsTelephonic] = useState(false);

  // Add this above inside your component
  // const [session, setSession] = useState(
  //   localStorage.getItem("Session") || "2025-26"
  // );
  const [session, setSession] = useState(() => {
    const storedSession = localStorage.getItem("Session");
    return storedSession && storedSession.trim() !== "" ? storedSession : "2025-26";
  });

  useEffect(() => {
    if (!localStorage.getItem("Session") || localStorage.getItem("Session")?.trim() === "") {
      localStorage.setItem("Session", "2025-26");
    }
  }, []);
  
  const [isSessionChanged, setIsSessionChanged] = useState(false); // New state to track session changes

  const handleSessionChange = (e) => {
    const value = e.target.value;
    resetFilters();
    setSession(value);
    setIsSessionChanged(true); // Mark session as changed
    localStorage.setItem("Session", value);
    window.location.reload();
  };

  useEffect(() => {
    // Ensure session is considered during the initial load
    const initialSession = localStorage.getItem("Session") || "2025-26";
    if (initialSession) {
      setSession(initialSession);
      getAllEnquiry({ page: activepage, limit: recperpage, ...(initialSession && { session: initialSession }) });
    } else {
      getAllEnquiry({ page: activepage, limit: recperpage });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // Dynamically inject CSS for scrollbar hiding, only for the sidebar
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }  /* For Chrome, Safari */
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }  /* For IE, Firefox */
    `;
    document.head.appendChild(styleElement);

    // Clean up the style when the component is unmounted
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const resetFilters = () => {
    setFilter([
      { field: "form_location", selected: [] },
      { field: "program", selected: [] },
      { field: "handled_by", selected: [] },
      { field: "assignedTo", selected: [] },
      { field: "admissionStatus", selected: [] },
      { field: "hasNewAssigneeResponded", selected: [] },
      { field: "isReassigned", selected: [] },
      { field: "date", selected: { start: "", end: "" } },
    ]);
  };

  // To get seperate count of all enquires
  useEffect(() => {
    EnquiryAPI.countLastMonthWalkInEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setLastMonthWalkInEnquiry(result?.data?.data?.lastMonth);
      } else {
        setLastMonthWalkInEnquiry(0);
      }
    });

    EnquiryAPI.countLastMonthAdEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setLastMonthAdEnquiry(result?.data?.data?.lastMonth);
      } else {
        setLastMonthAdEnquiry(0);
      }
    });

    EnquiryAPI.countLastMonthOrganicEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setLastMonthOrganicEnquiry(result?.data?.data?.lastMonth);
      } else {
        setLastMonthOrganicEnquiry(0);
      }
    });

    EnquiryAPI.countLastMonthWalkInEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setCurrentMonthWalkInEnquiry(result?.data?.data?.currentMonth);
      } else {
        setCurrentMonthWalkInEnquiry(0);
      }
    });
    EnquiryAPI.countLastMonthAdEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setCurrentMonthAdEnquiry(result?.data?.data?.currentMonth);
        // console.log(result?.data?.data?.currentMonth);
      } else {
        setCurrentMonthAdEnquiry(0);
      }
    });

    EnquiryAPI.countLastMonthOrganicEnquiry().then((result) => {
      // console.log(result);
      if (result?.data?.status) {
        setCurrentMonthOrganicEnquiry(result?.data?.data?.currentMonth);
      } else {
        setCurrentMonthOrganicEnquiry(0);
      }
    });

    EnquiryAPI.countTotatlEnquiry().then((result) => {
      // // console.log(result);
      if (result?.data?.status) {
        setTotalEnquiry(result?.data?.data);
      } else {
        setTotalEnquiry(0);
      }
    });

    OnlineEnquiryAPI.countTotatlEnquiry().then((result) => {
      if (result?.data?.status) {
        setTotalOnlineEnquiry(result?.data?.data);
      } else {
        setTotalOnlineEnquiry(0);
      }
    });

    OnlineEnquiryAPI.countAdEnquiry().then((result) => {
      if (result?.data?.status) {
        setTotalAdOnlineEnquiry(result?.data?.data);
      } else {
        setTotalAdOnlineEnquiry(0);
      }
    });
  }, []);

  useEffect(() => {
    top_loader(true, 45);
    getAllEnquiry({ page: activepage, limit: recperpage,  ...(session && { session }), });

    // eslint-disable-next-line

    const handleTransfer = async () => {
      const params = { page: 1, limit: 100 };

      try {
        const result = await UserAPI.getAllUsers(params);
        // console.log("---------data--------", result);

        // Filter users based on "counsellor" or "admission" roles
        const mainRoles = ["counsellor", "admission"];
        const filteredHandlers = result.data?.data?.filter(item =>
          item.role?.some(role => mainRoles.includes(role))
        );

        // console.log("TET 234", filteredHandlers);
        setHandlers(filteredHandlers);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    handleTransfer();
    return () => {
      if (
        activeData?.filter &&
        activeData.activepage &&
        activeData.recperpage
      ) {
        // window.alert(activeData.activepage+'!!')

        sessionStorage.setItem("activeData", JSON.stringify(activeData));
      }
    };
  }, []);

  useEffect(() => {
   // getAllEnquiry({ page: activepage, limit: recperpage,  ...(session && { session }), });
   const isDefaultFilter = filter.every((f) => {
    if (f.field === "date") {
      return f.selected?.start === "" && f.selected?.end === "";
    }
    return Array.isArray(f.selected) && f.selected.length === 0;
  });

  if (!isDefaultFilter) return; // Don't call if any filter is active

  //const session = localStorage.getItem("Session");

  const enquiryParams = {
    page: activepage,
    limit: recperpage,
    ...(session && { session }),
  };

  // console.log('Session is:',session)

  getAllEnquiry(enquiryParams);
  },[session])

  useEffect(() => {
    if (isSessionChanged) {
      // Only call the API when the session is changed
      getAllEnquiry({ page: activepage, limit: recperpage, ...(session && { session }) });
      setIsSessionChanged(false); // Reset the session change flag
    }
  }, [session]); // Trigger only when the session changes

  const getAllEnquiry = (params) => {
    setLoading(true);
    OnlineEnquiryAPI.getAllOnlineEnquiry(params).then((result) => {
      if (result.data.status) {
        // console.log(result.data);
        setDate(result.data.data);
        setTotalData(result.data.total);

        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
        // // console.log(data);
      } else {
        setDate([]);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
      }
    });
  };

  const filterPanelRef = useRef(null);

  // const handleSearchChange = (e) => {
  //   const { value } = e.target;
  //   SetSearch(value);

  // If the search field is emptied, reload all records
  // if (value.trim() === '') {
  //   getAllEnquiry({ page: activepage, limit: recperpage });
  // }
  // };

  function capitalizeWords(name) {
    const words = name.split(" ");
    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return capitalizedWords.join(" ");
  }

  const handleAssignment = async (event, _id) => {
    event.stopPropagation();
    event.preventDefault();

    const userRoles = cookie.get("role") ? cookie.get("role").split(",") : [];

    try {
      if (!userRoles.includes("counsellor")) {
        notify_error("Only Counsellors have access to walk-in Enquiries");
        return;
      }

      if (userRoles.includes("counsellor")) {
        const result = await EnquiryAPI.updateAssignment({
          _id: _id,
          username: cookie.get("name"),
        });

        // console.log(result);
        if (result.data.status) {
          notify_success(result.data.message);
          // getAllEnquiry({ page: activepage, limit: recperpage });
        } else {
          notify_error("Failed to update");
        }
      }
    } catch (err) {
      notify_error("Unauthorized Access. Only For Counsellors.");
    }
  };

  useEffect(() => {
    // console.log(step);
    // console.log(activepage, "active", recperpage);
  }, [step]);

  const fetchData = () => {
    setLoading(true);

    OnlineEnquiryAPI.getAllOnlineEnquiry({
      page: activepage,
      limit: recperpage,
      session:session
    })
      .then((result) => {
        if (result.data.status) {
          setDate(result.data.data);
          setTotalData(result.data.total);
          SetActivePage(1);
        } else {
          setDate([]);
          setTotalData(0);
        }

        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        // Handle errors if needed
        setLoading(false);
      });
  };

  const handleSearch = async (e) => {
    if (e.key === "Enter") {
      const searchTerm = e.target.value.trim();

      console.log(searchTerm);
      if (searchTerm === "") {
        fetchData();
      } else {
        try {
          setLoading(true);

          const res = await OnlineEnquiryAPI.searchQuery(
            { search: searchTerm },
            activepage,
            recperpage,
            session
            
          );

          setDate(res.data.data);
          setTotalData(res.data.total);
          SetActivePage(1);

          setLoading(false);
        } catch (error) {
          console.error("Error in handleSearch:", error);
          setLoading(false);
        }
      }
    }
  };

  let timer;

  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearch1(value);

    clearTimeout(timer);

    timer = setTimeout(() => {
      if (value.trim() === "") {
        fetchData(); // You can define fetchData to handle empty search case
      } else {
        fetchDataWithSearch(value.trim());
      }
    }, 300);
  };

  const fetchDataWithSearch = async (searchTerm) => {
    try {
      setLoading(true);

      const res = await OnlineEnquiryAPI.searchQuery(
        { search: searchTerm },
        activepage,
        recperpage,
        session,
      );

      setDate(res.data.data);
      setTotalData(res.data.total);
      SetActivePage(1);

      setLoading(false);
    } catch (error) {
      console.error("Error in handleSearch:", error);
      setLoading(false);
    }
  };
  const toggleFilterPanel = () => {
    setIsFilterPanelOpen((prev) => !prev);
  };

  function handleStatus(event, id) {
    event.stopPropagation();
    event.preventDefault();
    OnlineEnquiryAPI.updateStatus({
      _id: id,
      username: cookie.get("name"),
    }).then((result) => {
      if (result.data.status) {
        notify_success(result.data.message);
        getAllEnquiry({ page: activepage, limit: recperpage,  ...(session && { session }), });
      } else {
        notify_error("Failed to update");
      }
    });
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        filterPanelRef.current &&
        !filterPanelRef.current.contains(event.target)
      ) {
        setIsFilterPanelOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const handleType = (form_location) => {
    if (transferRole == "") {
      setTransferRole(form_location);
      return true;
    } else if (transferRole != "walk-in") {
      if (form_location == "walk-in") {
        notify_error("Select only Walk-in or non Walk-in at a time");
        return false;
      }
    } else if (transferRole == "walk-in") {
      if (form_location != "walk-in") {
        notify_error("Select only Walk-in or non Walk-in at a time");
        return false;
      }
    }
    return true;
  };

  const handleReassign = async (param) => {
    let role;
    if (transferRole == "walk-in") {
      role = "counsellor";
      if (param.role != "counsellor") {
        notify_error("Only Counsellor can handle these enquiry");
        return;
      }
    } else if (transferRole != "walk-in") {
      role = "admission";
    }

    const params = {
      _id: selectedRows,
      type: "multiple",
      newAssigned: `${param.firstname} ${param.lastname}`,
      user: cookie?.get("name"),
      role: role,
    };

    OnlineEnquiryAPI.assignHandlerOne(params)
      .then((res) => {
        notify_success("Enquiry Successfully Updated");
        setActiveTransfer(false);
        getAllEnquiry({ page: activepage, limit: recperpage,  ...(session && { session }), });
        // window.location.reload();
      })
      .catch((err) => {
        notify_error(err.message);
      });
  };

  const handleRefresh = () => {
    SetActivePage(1);
    resetFilters();
    // Fetch data again
    //getAllEnquiry({ page: activepage, limit: recperpage,  ...(session && { session }), });
    window.location.reload();
  };

  useEffect(() => {
    // console.log(enquiry);
    if (enquiry.form_location === "telephonic") {
      setIsTelephonic(true);
    }
    if (enquiry.form_location === "walk-in") {
      setIsTelephonic(false);
    }
  }, [enquiry]);

  useEffect(() => {
    if (selectedRows?.length == 0) {
      setTransferRole("");
    }
  }, [selectedRows]);

  // useEffect(async () => {
  //   let hand;

  //   if (transferRole == "walk-in") {
  //     const params = { page: 1, limit: 100 };

  //     await UserAPI.getAllUsers(params).then((result) => {
  //       hand = result.data?.data.filter((item) => item.role === "counsellor");
  //       setHandlers(hand);
  //     });
  //   } else if (transferRole != "walk-in" && transferRole !== "") {
  //     const params = { page: 1, limit: 100 };

  //     await UserAPI.getAllUsers(params).then((result) => {
  //       hand = result.data?.data.filter((item) => item.role === "admission");
  //       setHandlers(hand);
  //     });
  //   } else {
  //     // This else block is not needed for a useEffect function. useEffect doesn't return anything.
  //     // If you don't want to make any changes in the last case, you can simply omit the else block.
  //     // If you want to do something in the else case, just add it without a return statement.
  //   }
  // }, [transferRole]);

  const handleRowSelection = (event, rowId, form_location) => {
    event.stopPropagation();
    event.preventDefault();

    if (handleType(form_location)) {
      if (selectedRows.includes(rowId)) {
        setSelectedRows(selectedRows.filter((id) => id !== rowId));
      } else {
        setSelectedRows([...selectedRows, rowId]);
      }
    } else {
      return;
    }

    // console.log(selectedRows)
  };

  const handleEnquiryOpen = (e) => {
    e.preventDefault();
    setOpen((prev) => !prev);
  };

  // Calculation of Walk-in growth
  let walk_in_growth =
    ((currentMonthWalkInEnquiry - lastMonthWalkInEnquiry) /
      lastMonthWalkInEnquiry) *
    100;
  if (!isFinite(walk_in_growth) || isNaN(walk_in_growth)) {
    walk_in_growth = 100;
  }
  const formatted_walk_in_growth = walk_in_growth.toFixed(2);

  // Calculation of online/organic growth
  let online_growth =
    ((currentMonthOrganicEnquiry - lastMonthOrganicEnquiry) /
      lastMonthOrganicEnquiry) *
    100;
  if (!isFinite(online_growth) || isNaN(online_growth)) {
    online_growth = 100;
  }
  const formatted_online_growth = online_growth.toFixed(2);

  // Calculation of Advertisement growth
  let ad_growth =
    ((currentMonthAdEnquiry - lastMonthAdEnquiry) / lastMonthAdEnquiry) * 100;
  if (!isFinite(ad_growth) || isNaN(ad_growth)) {
    ad_growth = 100;
  }
  const formatted_ad_growth = ad_growth.toFixed(2);

  // Calculation of Total growth
  let total_growth =
    ((currentMonthAdEnquiry +
      currentMonthOrganicEnquiry +
      currentMonthWalkInEnquiry -
      (lastMonthAdEnquiry + lastMonthOrganicEnquiry + lastMonthWalkInEnquiry)) /
      (lastMonthAdEnquiry + lastMonthOrganicEnquiry + lastMonthWalkInEnquiry)) *
    100;
  if (!isFinite(total_growth) || isNaN(total_growth)) {
    total_growth = 100;
  }
  const formatted_total_growth = total_growth.toFixed(2);

  // console.log("line 899:", data);

  const handleRecPerPageChange = (event) => {
    const newRecPerPage = event.target.value;
    SetRecPerPage(newRecPerPage);
    SetActivePage(1); // Reset to the first page
    getAllEnquiry({ page: 1, limit: newRecPerPage, ...(session && { session }) }); // Include session in the API call
  };

  return (
    <div
      className="custom-sidebar"
      style={{ height: "100vh", overflowY: "auto", width: "100vw" }}
    >
      {step == 1 && (
        <>
          <Container fluid style={{ fontFamily: "Inter" }}>
            <Row className=" my-0">
              <Col lg={12}>
                <div className="" style={{ marginTop: "80px" }}>
                  {/* Count and Stats of Enquiry in Main Enquiry table */}
                  <div
                    className=""
                    style={{
                      boxShadow: "10px 10px 10px 0px rgba(0, 31, 51, 0.10)",
                    }}
                  >
                    <div className="enquiryStats col-md-12 d-flex">
                      <div className="total-walk-in-enquiry d-flex col-md-3 px-3 py-3">
                        <div className="statHeading1">
                          Total Walk-In Enquiry
                        </div>
                        <div className="statHeading1">{totalEnquiry}</div>
                      </div>

                      <div className="total-walk-in-enquiry d-flex col-md-3 px-3 py-3">
                        <div className="statHeading1">Total Online Enquiry</div>
                        <div className="statHeading1">
                          {totalAdOnlineEnquiry}
                        </div>
                      </div>

                      <div className="total-walk-in-enquiry d-flex col-md-3 px-3 py-3">
                        <div className="statHeading1">
                          Online Ad-Page Enquiry
                        </div>
                        <div className="statHeading1">{totalOnlineEnquiry}</div>
                      </div>

                      <div className="total-walk-in-enquiry-1 d-flex col-md-3 px-3 py-3">
                        <div className="statHeading1">Total Enquiry</div>
                        <div className="statHeading1">
                          {totalEnquiry +
                            totalAdOnlineEnquiry +
                            totalOnlineEnquiry}
                        </div>
                      </div>
                    </div>

                    <div className="enquiryStats1 col-md-12 d-flex">
                      <div className="statGrowth d-flex col-md-3 px-3 py-2">
                        <div className="statHeading2">Last Month</div>
                        <div className="statHeading2">
                          {lastMonthWalkInEnquiry}
                        </div>
                      </div>
                      <div className="statGrowth d-flex col-md-3 px-3  ">
                        <div className="statHeading2">Last Month</div>
                        <div className="statHeading2">
                          {lastMonthOrganicEnquiry}
                        </div>
                      </div>
                      <div className="statGrowth d-flex col-md-3 px-3 ">
                        <div className="statHeading2">Last Month</div>
                        <div className="statHeading2">{lastMonthAdEnquiry}</div>
                      </div>
                      <div className="statGrowth-1 d-flex col-md-3 px-3 ">
                        <div className="statHeading2">Last Month</div>
                        <div className="statHeading2">
                          {lastMonthOrganicEnquiry +
                            lastMonthWalkInEnquiry +
                            lastMonthAdEnquiry}
                        </div>
                      </div>
                    </div>

                    <div className="enquiryStats1 col-md-12 d-flex mb-4">
                      <div className="statGrowth1 d-flex col-md-3 px-3 py-2 ">
                        <div className="statHeading2">Growth</div>
                        <div className="statHeading3">
                          {formatted_walk_in_growth}%
                        </div>
                      </div>

                      <div className="statGrowth1 d-flex col-md-3 px-3 ">
                        <div className="statHeading2">Growth</div>
                        <div className="statHeading3">
                          {formatted_online_growth}%
                        </div>
                      </div>

                      <div className="statGrowth1 d-flex col-md-3 px-3 ">
                        <div className="statHeading2">Growth</div>
                        <div className="statHeading3">
                          {formatted_ad_growth}%
                        </div>
                      </div>

                      <div className="statGrowth1-1 d-flex col-md-3 px-3 ">
                        <div className="statHeading2">Growth</div>
                        <div className="statHeading3">
                          {formatted_total_growth}%
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Search Button , Other Functionalities */}
                  <div
                    lg={12}
                    className="bg-white mx-0 my-1 rounded"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {/* Search button */}
                    <div style={{ display:"flex", flexDirection:"row", marginLeft: "12px", width: "25%" }}>
                      {/* Set width to 20% */}
                      <InputGroup
                        className="my-2"
                        style={{
                          borderRadius: "8px", // Rounded corners
                          border: "1px solid #D1D5DB", // Light border
                          backgroundColor: "#F8F9FB", // Light background
                          height: "43px", // Fixed height
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#F8F9FB",
                            paddingLeft: "11px",
                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            height: "100%", // Ensures the icon container takes the full height
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {/* Uncomment and use the icon if needed */}
                          {/* <img src="/assets/images/dashboard/search.png" alt="search icon" /> */}
                        </div>

                        <Form.Control
                          placeholder="Search by Name, Email and Mobile Number"
                          aria-label="Search"
                          name="search"
                          style={{
                            backgroundColor: "#F8F9FB",
                            border: "none", // No inner border
                            fontFamily: "Inter",
                            paddingLeft: "0px",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            fontSize: "12px", // Adjust font size
                            color: "#6B7280", // Placeholder color
                            height: "100%", // Ensures the input field takes the full height
                          }}
                          onChange={handleSearchChange}
                          value={search1}
                          onKeyPress={handleSearch}
                        />
                      </InputGroup>
                      <div>
                      <p style={{whiteSpace:"nowrap", marginTop:"18px", marginLeft:"4px"}}> Total Results: <span>{totalData}</span></p>
                      
                    </div>
                    </div>
                   

                   


                    <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                      {/* Button Group */}
                      <div className="d-flex align-items-center mx-1 mt-2 mt-sm-0">
                      <div className="d-flex align-items-center mx-2 mb-2" style={{ marginTop: "10px" }}>
                      <div className=" mx-2">Session:</div>
                      <select
                        value={session}
                        onChange={handleSessionChange}
                        style={{
                          height: "43px",
                          borderRadius: "8px",
                          border: "1px solid #D1D5DB",
                          backgroundColor: "#F8F9FB",
                          fontFamily: "Inter",
                          fontSize: "14px",
                          color: "#374151",
                          padding: "0 12px",
                        }}
                      >
                        <option value="2026-2027">2026-27</option>
                        <option value="2025-2026">2025-26</option>
                        <option value="2024-2025">2024-25</option>
                        
                      </select>
                    </div>
                        {/* Add Enquiry Button */}
                        <div style={{ padding: "0", margin: "0" }}>
                          <Button
                            onClick={handleEnquiryOpen}
                            style={{
                              backgroundColor: "#663399", // Updated color
                              borderColor: "#663399", // Updated border color
                              color: "#ffffff", // Text color updated to white
                              width: "auto",
                              // padding: "12px 16px",
                              paddingBlock: "10px",
                              height: "43px",
                              whiteSpace: "nowrap",
                              borderRadius: "8px",
                            }}
                          >
                            <i className="fa-solid fa-user-plus me-2"></i>Add
                            Enquiry
                          </Button>
                        </div>

                        {/* Dropdown for Transfer To */}
                        <div className="d-flex align-items-center mx-2">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="info"
                              className="px-4 my-2"
                              size="sm"
                              style={{
                                backgroundColor: "#663399", // Updated color
                                color: "#ffffff", // Text color updated to white
                                borderColor: "#663399", // Updated border color
                                // fontSize: "15px",
                                // fontWeight: "lighter",
                                width: "auto",
                                paddingBlock: "10px",
                                fontFamily: "Inter",
                                height: "43px",
                                borderRadius: "8px",
                              }}
                            >
                              Transfer To
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {handlers &&
                                handlers.map((user) => (
                                  <Dropdown.Item
                                    onClick={() => handleReassign(user)}
                                    key={user.id}
                                    className="transferTo"
                                    style={{
                                      backgroundColor: "#ffffff",
                                      color: "#000",
                                    }}
                                  >
                                    {`${user.firstname
                                      .charAt(0)
                                      .toUpperCase()}${user.firstname.slice(
                                        1
                                      )} ${user.lastname}`}
                                  </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* Filter Button */}
                        <div className="d-flex align-items-center mx-1">
                          <button
                            type="button"
                            className="btn btn-primary dropdown-toggle"
                            onClick={toggleFilterPanel}
                            style={{
                              backgroundColor: "#BBC5EA",
                              borderColor: "#BBC5EA",
                              color: "#000000",
                              height: "43px",
                              padding: "11px 15px",
                              borderRadius: "8px",
                            }}
                          >
                            Filter&nbsp;
                            <i className="fa fa-filter" aria-hidden="true"></i>
                          </button>
                        </div>

                        {/* WhatsApp Icon */}
                        <div className="d-flex align-items-center mx-1">
                          <WhatsAppIcon
                            fontSize="large"
                            color="disabled"
                            className="my-auto"
                            cursor="pointer"
                          />
                        </div>

                        {/* Refresh Icon */}
                        <div className="d-flex align-items-center mx-1">
                          <RefreshOutlinedIcon
                            fontSize="large"
                            color="disabled"
                            cursor="pointer"
                            onClick={handleRefresh}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      marginBottom: "25px",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <div
                      className="maintable p-0 "
                      id="table-container"
                      style={{ height: "auto", width: "auto" }}
                    >
                      {loading ? (
                        <TableSkeleton rows={10} columns={10} hasActions={false} />
                      ) : (
                        <table className="col-md-12 enquiryTable">
                        <thead className="tableHeadAllEnquiry">
                          <tr className="tableHeading">
                            <th>Select</th>
                            <th>S.No.</th>
                            <th>Name</th>
                            <th>Mobile</th>
                            <th>Email</th>
                            <th>Program</th>
                            <th>Origin</th>
                            <th>Location</th>
                            <th style={{ width: "15%" }}>Status</th>
                            <th>Handler</th>
                            <th style={{ width: "15%" }}>Created At</th>
                          </tr>
                        </thead>

                        <tbody className="mt-1">
                          {data?.length > 0 &&
                            data
                              .filter((item) => !item.is_old) // Filter out objects where is_old is false
                              .map((item, index) => {
                                const rowId = item._id;
                                return (
                                  <>
                                    <tr className="tableRows" key={item._id}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          checked={selectedRows.includes(rowId)}
                                          onChange={(e) =>
                                            handleRowSelection(
                                              e,
                                              rowId,
                                              item.form_location
                                            )
                                          }
                                        />
                                      </td>

                                      <td
                                        onClick={() => {
                                          setIndex(index);
                                          localStorage.setItem("index", index);
                                          window.open(
                                            `/dashboard/lead-profile/${item._id}`,
                                            "_blank"
                                          );
                                        }}
                                      >
                                        {!item.repeat && (
                                          <span>{sno + index + 1}</span>
                                        )}
                                        {item.repeat && (
                                          <span
                                            style={{
                                              display: "flex",
                                              // position:'relative',
                                              justifyContent: "space-around",
                                              alignItems: "",
                                            }}
                                          >
                                            {sno + index + 1}
                                            {/* <Badge.Ribbon
                                              style={{
                                                fontSize: "8px",
                                                right: "-20px",
                                                position: "absolute",
                                              }}
                                              color="#f50"
                                              placement="end"
                                              text="DUP"
                                            /> */}
                                          </span>
                                        )}
                                      </td>

                                      <td
                                        onClick={() => {
                                          // setActiveId(item._id);
                                          setIndex(index);
                                          localStorage.setItem("index", index);
                                          window.open(
                                            `/dashboard/lead-profile/${item._id}`,
                                            "_blank"
                                          );
                                          // setStep(2);
                                        }}
                                      >
                                        {capitalizeWords(item.name)}
                                      </td>

                                      <td>
                                        <MaskedField
                                          value={item.mobile_number}
                                          leadId={item._id}
                                          field="mobile"
                                        />
                                      </td>

                                      <td>
                                        <MaskedField
                                          value={item.email}
                                          leadId={item._id}
                                          field="email"
                                        />
                                      </td>

                                      <td
                                        onClick={() => {
                                          setIndex(index);
                                          localStorage.setItem("index", index);
                                          // setActiveId(item._id);
                                          window.open(
                                            `/dashboard/lead-profile/${item._id}`,
                                            "_blank"
                                          );

                                          // setStep(2);
                                        }}
                                      >
                                        {item?.program?.toUpperCase()}
                                      </td>

                                      <td
                                        onClick={() => {
                                          // setActiveId(item._id);
                                          setIndex(index);
                                          localStorage.setItem("index", index);
                                          window.open(
                                            `/dashboard/lead-profile/${item._id}`,
                                            "_blank"
                                          );

                                          // setStep(2);
                                        }}
                                      >
                                        {item?.form_location?.toUpperCase()}
                                      </td>

                                      <td
                                        onClick={() => {
                                          // setActiveId(item._id);
                                          setIndex(index);
                                          localStorage.setItem("index", index);
                                          window.open(
                                            `/dashboard/lead-profile/${item._id}`,
                                            "_blank"
                                          );

                                          // setStep(2);
                                        }}
                                      >
                                        {item.state
                                          ? `${item?.state} ${item?.city || ""
                                            }`?.toUpperCase()
                                          : "N/A"}
                                      </td>

                                      {!item.admissionStatus && (
                                        <td
                                          className="border-0 "
                                          onClick={() =>
                                            window.open(
                                              `/dashboard/lead-profile/${item._id}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          N/A
                                        </td>
                                      )}
                                      {item.admissionStatus == "in-process" && (
                                        <td
                                          className=""
                                          onClick={() =>
                                            window.open(
                                              `/dashboard/lead-profile/${item._id}`,
                                              "_blank"
                                            )
                                          }
                                        >
                                          <span
                                            className=""
                                            style={{
                                              color: "#FFB800",
                                              border: "none",
                                              backgroundColor: "#FFEDC0",
                                              zIndex: "1000",
                                              paddingTop: "3px",
                                              paddingBottom: "3px",
                                              paddingLeft: "13px",
                                              paddingRight: "13px",
                                              borderRadius: "4px",
                                            }}
                                          >
                                            {item?.admissionStatus
                                              ? item?.admissionStatus?.toUpperCase()
                                              : "N/A"}
                                          </span>
                                        </td>
                                      )}
                                      {item.admissionStatus ==
                                        "admission-taken" && (
                                          <td
                                            className=""
                                            onClick={() =>
                                              window.open(
                                                `/dashboard/lead-profile/${item._id}`,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <span
                                              className=""
                                              style={{
                                                color: "#46CF85",
                                                border: "none",
                                                backgroundColor: "#CAEEDB",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "13px",
                                                paddingRight: "13px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              {item?.admissionStatus
                                                ? item?.admissionStatus?.toUpperCase()
                                                : "N/A"}
                                            </span>
                                          </td>
                                        )}
                                      {item.admissionStatus ==
                                        "not-interested" && (
                                          <td
                                            className=""
                                            onClick={() =>
                                              window.open(
                                                `/dashboard/lead-profile/${item._id}`,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <span
                                              className=" "
                                              style={{
                                                color: "#F7685B",
                                                border: "none",
                                                backgroundColor: "#FFE3E0",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "13px",
                                                paddingRight: "13px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              {item?.admissionStatus
                                                ? item?.admissionStatus?.toUpperCase()
                                                : "N/A"}
                                            </span>
                                          </td>
                                        )}

                                      {item.admissionStatus ==
                                        "not-eligible" && (
                                          <td
                                            className=""
                                            onClick={() =>
                                              window.open(
                                                `/dashboard/lead-profile/${item._id}`,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <span
                                              className=" "
                                              style={{
                                                color: "#F7685B",
                                                border: "none",
                                                backgroundColor: "#FFE3E0",
                                                paddingTop: "3px",
                                                paddingBottom: "3px",
                                                paddingLeft: "13px",
                                                paddingRight: "13px",
                                                borderRadius: "4px",
                                              }}
                                            >
                                              {item?.admissionStatus
                                                ? item?.admissionStatus?.toUpperCase()
                                                : "N/A"}
                                            </span>
                                          </td>
                                        )}
                                      {/* style={{
                              
                              backgroundColor: item?.admissionStatus === "Not interested"? "blue" :
                               item?.admissionStatus === "in-process"? "green" :
                               item?.admissionStatus === "admission-taken"? "red" :""
                            }} */}

                                      <td>
                                        {item.form_location === "walk-in" &&
                                          !item.assignedTo && (
                                            <>
                                              <a
                                                className="bg-transparent border-0"
                                                style={{
                                                  color: "#663399",
                                                  fontWeight: "600",
                                                  borderBottom:
                                                    "1px solid #663399",
                                                }}
                                                onClick={(e) =>
                                                  handleAssignment(e, item._id)
                                                }
                                              >
                                                Assign To Me
                                              </a>
                                            </>
                                          )}
                                        {(item.form_location ===
                                          "website-pop-up" ||
                                          item.form_location === "ad-page" ||
                                          item.form_location ===
                                          "online-query" ||
                                          item.form_location === "telephonic" ||
                                          item.form_location ===
                                          "get-admission-walk-in" ||
                                          item.form_location ===
                                          "existing-student" ||
                                          item.form_location ===
                                          "college-dekho-walk-in" ||
                                          item.form_location ===
                                          "other-consultant-walk-in" ||
                                          item.form_location ===
                                          "college-dekho") &&
                                          !item.handled_by && (
                                            <>
                                              <a
                                                className="bg-transparent border-0"
                                                style={{
                                                  color: "#663399",
                                                  fontWeight: "600",
                                                  borderBottom:
                                                    "1px solid #663399",
                                                }}
                                                onClick={(e) =>
                                                  handleStatus(e, item._id)
                                                }
                                              >
                                                Assign To Me
                                              </a>
                                            </>
                                          )}
                                        {item.form_location === "walk-in" &&
                                          item.assignedTo &&
                                          item.assignedTo.toUpperCase()}
                                        {(item.form_location ===
                                          "website-pop-up" ||
                                          item.form_location ===
                                          "online-query" ||
                                          item.form_location === "telephonic" ||
                                          item.form_location === "ad-page" ||
                                          item.form_location ===
                                          "get-admission-walk-in" ||
                                          item.form_location ===
                                          "existing-student" ||
                                          item.form_location ===
                                          "college-dekho-walk-in" ||
                                          item.form_location ===
                                          "other-consultant-walk-in" ||
                                          item.form_location ===
                                          "college-dekho") &&
                                          item.handled_by &&
                                          item.handled_by.toUpperCase()}
                                      </td>
                                      <td>
                                        {new Intl.DateTimeFormat("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "numeric",
                                          hour: "2-digit",
                                          minute: "2-digit",
                                        }).format(new Date(item.created_at))}
                                      </td>
                                    </tr>
                                  </>
                                );
                              })}
                          {data.length == "0" && (
                            <>
                              <div className="d-flex align-items-center justify-content-center">
                                <h1 className="text-muted">NO DATA</h1>
                              </div>
                            </>
                          )}
                        </tbody>
                      </table>
                      )}
                    </div>
                    {/* <div className="tableEnd"></div> */}

                    <div className="col-md-12 form-inline py-2 tableFooter d-flex gap-5 align-items-center">
                      <div className="col-md-4 d-flex gap-2 align-baseline">
                        <label
                          className="control-label col-md-4"
                          style={{
                            fontWeight: "700",
                            paddingTop: "5px",
                            paddingLeft: "25px",
                          }}
                        >
                          Rows per page :
                        </label>
                        {/* <i className="pi pi-chevron-down" style={{position:"absolute" , left:"92%", top:"15%"}}/> */}
                        <Form.Select
                          className="form-control "
                          onChange={handleRecPerPageChange} // Updated to use the new handler
                          value={recperpage}
                          style={{
                            border: "solid",
                            borderWidth: "thin",
                            color: "#000",
                          }}
                        >
                          <option value="10">10</option>
                          <option value="25">25</option>
                          <option value="50">50</option>
                          <option value="75">75</option>
                          <option value="100">100</option>
                          <option value="200">200</option>
                        </Form.Select>
                      </div>

                      <div
                        className="col-md-8 d-flex gap-2"
                        style={{
                          justifyContent: "end",
                          alignItems: "center",
                          paddingRight: "60px",
                        }}
                      >
                        <Pagination
                          total={totalData}
                          showSizeChanger={false}
                          current={activepage}
                          size="small"
                          // showQuickJumper
                          pageSize={recperpage}
                          onChange={(page, pageSize) => {
                            SetActivePage(page);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>

          <div
            ref={filterPanelRef}
            className={`filter-panel${isFilterPanelOpen ? " open" : ""}`}
            id="handler-container"
            // Style the slide-out panel as per your requirement
            style={{
              position: "fixed",
              top: "0",
              right: `${isFilterPanelOpen ? "0" : "-100%"}`,
              width: "450px",
              height: "100vh",
              overflowY: "auto",
              background: "#fff",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
              transition: "right 0.3s ease-in-out",
            }}
          >
            <FilterOnlineEnquiry session={session} />
          </div>
          {open && <CreateEnquiry open={open} setOpen={setOpen} />}
        </>
      )}

      {step == 2 && (
        <>
          <LeadProfile
            setStep={setStep}
            activepage={activepage}
            recperpage={recperpage}
            index={Index}
            id={activeId}
          />
        </>
      )}
    </div>
  );
};

export default EnquiryTable;
